import React, { useState, useEffect } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import Header from '../Header/index'
import Footer from '../Footer/index'
import Home from '../Home/index'
import { LoaderPending } from '../loadingPending'

import { useWeb3React } from '@web3-react/core'
import WalletConnectProvider from '@walletconnect/web3-provider'
import WalletConnect from '@walletconnect/client'
import QRCodeModal from '@walletconnect/qrcode-modal'

import $ from 'jquery'
import Web3 from 'web3'
import { ethers } from 'ethers'
import Web3Modal from 'web3modal'
import { Affix } from 'antd'
import {
  getWalletProvider,
  setWalletType,
  setWalletAmount,
  setWalletAddress,
  setConnection
} from '../ConnectWallet/walletConnectReducer'
import OldRewardesign from '../reward-old-design'
import { useDisconnect } from '@walletconnect/modal-sign-react'
const Login1 = React.lazy(() => import('../Login/index'))
const Signup1 = React.lazy(() => import('../Signup/index'))
const ForgetPassword1 = React.lazy(() => import('../Login/ForgetPassword'))
const ResetPassword1 = React.lazy(() => import('../Login/ResetPassword'))
const ConnectWallet1 = React.lazy(() => import('../ConnectWallet/index'))
const Cards1 = React.lazy(() => import('../marketplace/index'))
const SearchNFTS1 = React.lazy(() => import('../SearchNFTS/index'))
const MyAlbum1 = React.lazy(() => import('../MyAlbum/index'))
const Slider1 = React.lazy(() => import('../sliders/index'))
const MyProfile1 = React.lazy(() => import('../MyProfile/index'))
const Reward1 = React.lazy(() => import('../Reward/index'))
const Rewardlisting1 = React.lazy(() => import('../Rewardlisting/index'))
const RewardDetail1 = React.lazy(() => import('../RewardDetail/index'))
const SportsTv1 = React.lazy(() => import('../tvSport/sport'))
const MyWallet1 = React.lazy(() => import('../mywallet/index'))
const ActivateAccount1 = React.lazy(() => import('../activateAccount/index'))
const Term1 = React.lazy(() => import('../termandPrivacy/index'))
const Privacy1 = React.lazy(() => import('../termandPrivacy/Privacy'))
const RoadMap1 = React.lazy(() => import('../termandPrivacy/RoadMap'))
const Aboutus1 = React.lazy(() => import('../termandPrivacy/About'))
const Contactus1 = React.lazy(() => import('../termandPrivacy/Contactus'))
const Partnership1 = React.lazy(() => import('../termandPrivacy/Partnership'))
const BuyNftDetail1 = React.lazy(() => import('../buyScreen/index'))
const SessionExpire1 = React.lazy(() => import('../sessionExpire'))
const MetaMask1 = React.lazy(() => import('../metamaskconnectivity'))
const OKXConnectivity = React.lazy(() => import('../okxConnectvity'))
const Success1 = React.lazy(() => import('../success'))
const TopUp1 = React.lazy(() => import('../topup'))
const FAQ1 = React.lazy(() => import('../termandPrivacy/FAQ'))
const MobileFAQ1 = React.lazy(() => import('../termandPrivacy/MobileFAQ'))
const UtlStram1 = React.lazy(() => import('../tvSport/utlStram'))
const NotFound1 = React.lazy(() => import('../NotFound'))
const VerifyAccount = React.lazy(() => import('../verify'))

function Router(props) {
  const { WalletConnectionProvider } = useSelector(state => state.walletConnect)
  const {
    connector,
    library,
    chainId,
    account,
    activate,
    deactivate,
    active,
    error
  } = useWeb3React()
  const [search, setSearch] = useState(false)
  const [searchQuery, setSearchQuery] = useState('')
  const [activatingConnector, setActivatingConnector] = React.useState()
  const dispatch = useDispatch()
  const [loaded, setLoaded] = useState(false)
  const [count, setCount] = useState(1)
  React.useEffect(() => {
    console.log(connector)
    console.log(activatingConnector)
    if (connector == undefined && activatingConnector != undefined) {
      setActivatingConnector(undefined)
      // alert('Please connect to a wallet')
      dispatch(setWalletAddress(''))
      dispatch(getWalletProvider(null))
      dispatch(setWalletType(null))
    } else {
      setActivatingConnector(connector)
    }
  }, [connector])

  useEffect(() => {
    const walletConnect = localStorage?.getItem('walletconnect')

    if (walletConnect != null && walletConnect != undefined) {
      ExWalletConnect()
    }
  }, [])

  const BinanceProvider = {
    type: String,
    chain: 'polygon',
    provider: Object,
    ERC20: [],
    explorer: String,
    sockets: String,
    web3Mod: Object
  }
  const chainId2 =
    localStorage.getItem('currentNetwork') != undefined
      ? localStorage.getItem('currentNetwork') == 'MUMBAI'
        ? `${process.env.REACT_APP_PLOYGON_CHAINID}`
        : localStorage.getItem('currentNetwork') == 'EHETERUM'
          ? `${process.env.REACT_APP_ETHERUM_CHAINID}`
          : `${process.env.REACT_APP_BINANCE_CHAINID}`
      : `${process.env.REACT_APP_PLOYGON_CHAINID}`
  const rpc2 =
    localStorage.getItem('currentNetwork') != undefined
      ? localStorage.getItem('currentNetwork') == 'MUMBAI'
        ? `${process.env.REACT_APP_MUMBAI_RPC}`
        : localStorage.getItem('currentNetwork') == 'EHETERUM'
          ? `${process.env.REACT_APP_RINKEY_RPC}`
          : `${process.env.REACT_APP_BINANCE_RPC}`
      : `${process.env.REACT_APP_MUMBAI_RPC}`
  const mumbaiProvider = {
    walletconnect: {
      package: WalletConnectProvider,
      options: {
        infuraId: undefined,
        rpc: {
          // 1: `${process.env.REACT_APP_RPC}`,
          [parseInt(chainId2)]: rpc2
        },
        supportedChainIds: [rpc2],
        chainId: rpc2,

        pollingInterval: 20000
      }
    }
  }
  const providerOptions = {
    walletconnect: {
      package: WalletConnectProvider,
      options: {
        infuraId: undefined,
        rpc: {
          // 1: `https://nodes.ex-sports.io/`,
          [parseInt(
            `${process.env.REACT_APP_BINANCE_CHAINID}`
          )]: `${process.env.REACT_APP_BINANCE_RPC}`
        },
        supportedChainIds: [`${process.env.REACT_APP_BINANCE_RPC}`],
        chainId: `${process.env.REACT_APP_BINANCE_RPC}`,

        pollingInterval: 20000
      }
    }
  }

  const ExWalletConnect = async () => {
    const bridge = 'https://bridge.walletconnect.org'

    // create new connector
    const provider =
      localStorage.getItem('currentNetwork') != undefined
        ? localStorage.getItem('currentNetwork') == 'MUMBAI'
          ? mumbaiProvider
          : providerOptions
        : mumbaiProvider
    const connector = new WalletConnect({ bridge, qrcodeModal: QRCodeModal })

    // console.log(providerOptions)
    console.log(connector?.WalletConnect)
    const web3Modal = new Web3Modal({
      provider
    })
    BinanceProvider.provider = connector
    BinanceProvider.web3Mod = web3Modal

    console.log(BinanceProvider)

    // check if already connected
    if (!connector.connected) {
      // create new session
      await connector.createSession()
    }

    connector.on('session_update', async (error, payload) => {
      console.log(`connector.on("session_update")`)

      if (error) {
        throw error
      }

      const { chainId, accounts } = payload.params[0]
      console.log(accounts)
      getbalance(accounts[0])
      // connectWallet({ wallet_connect: accounts[0] })
      dispatch(setConnection(connector))
      dispatch(setWalletAddress(accounts[0]))
      dispatch(getWalletProvider(BinanceProvider))
      dispatch(setWalletType('WALLETCONNECT'))
      // setWalletconnectloaded(false)
    })

    connector.on('connect', (error, payload) => {
      console.log(`connector.on("connect")`)

      if (error) {
        throw error
      }

      const { chainId, accounts } = payload.params[0]
      console.log(accounts)
      getbalance(accounts[0])
      // connectWallet({ wallet_connect: accounts[0] })
      dispatch(setWalletAddress(accounts[0]))
      dispatch(getWalletProvider(connector))
      dispatch(setConnection(connector))
      dispatch(setWalletType('WALLETCONNECT'))
    })

    connector.on('disconnect', (error, payload) => {
      console.log(`connector.on("disconnect")`)
      if (error) {
        throw error
      }
      // if (connector) {
      //     connector.killSession();
      // }

      dispatch(setWalletAddress(''))
      dispatch(getWalletProvider(null))
      dispatch(setWalletType(null))
      dispatch(setConnection(null))
      try {
        var x = document.getElementsByTagName('BODY')?.[0]
        x.style.overflowY = 'scroll'
        x.style.paddingRight = 'unset'
        var elements = document.getElementsByClassName('modal-backdrop')
        for (var i = 0; i <= elements?.length; i++) {
          elements[i].style.display = 'none'
        }
      } catch (e) {
      } finally {
      }
    })

    if (connector.connected) {
      const { chainId, accounts } = connector
      const address = accounts[0]
      getbalance(accounts[0])
      // connectWallet({ wallet_connect: accounts[0] })
      dispatch(setWalletAddress(accounts[0]))
      dispatch(getWalletProvider(connector))
      dispatch(setConnection(connector))
      dispatch(setWalletType('WALLETCONNECT'))
    }
  }

  const Provider = {
    type: String,
    chain: 'polygon',
    provider: Object,
    ERC20: [],
    explorer: String,
    sockets: String,
    web3Mod: Object
  }

  const chainId1 =
    localStorage.getItem('currentNetwork') != undefined
      ? localStorage.getItem('currentNetwork') == 'MUMBAI'
        ? `${process.env.REACT_APP_PLOYGON_CHAINID}`
        : localStorage.getItem('currentNetwork') == 'EHETERUM'
          ? `${process.env.REACT_APP_ETHERUM_CHAINID}`
          : `${process.env.REACT_APP_BINANCE_CHAINID}`
      : `${process.env.REACT_APP_PLOYGON_CHAINID}`
  const rpc =
    localStorage.getItem('currentNetwork') != undefined
      ? localStorage.getItem('currentNetwork') == 'MUMBAI'
        ? `${process.env.REACT_APP_MUMBAI_RPC}`
        : localStorage.getItem('currentNetwork') == 'EHETERUM'
          ? `${process.env.REACT_APP_RINKEY_RPC}`
          : `${process.env.REACT_APP_BINANCE_RPC}`
      : `${process.env.REACT_APP_MUMBAI_RPC}`
  const providerOptions1 = {
    walletconnect: {
      package: '',
      options: {
        infuraId: undefined,
        rpc: {
          // 1: `${process.env.REACT_APP_RPC}`,
          [parseInt(chainId1)]: rpc
        },
        supportedChainIds: [rpc],
        chainId: rpc,

        pollingInterval: 20000
      }
    }
  }

  useEffect(() => {
    // alert("Topup Successful")
    console.log(localStorage.getItem('topup'))
    if (
      localStorage.getItem('wc@2:client:0.3//session') != null &&
      localStorage.getItem('wc@2:client:0.3//session') != undefined
    ) {
      if (WalletConnectionProvider == null && loaded == false) {
        walletConnection()
        // setLoaded(true)
      }
    }
    if (
      localStorage.getItem('topup') != null &&
      localStorage.getItem('topup') != undefined
    ) {
      // if (localStorage.getItem("WalletConnected") == "true") {
      // alert("Topup Successful")
      walletConnection()
      localStorage.removeItem('topup')
      // }
    }
  }, [WalletConnectionProvider])

  const walletConnection = async () => {
    // localStorage.removeItem('WalletConnected')
    dispatch(setWalletAddress(''))
    dispatch(getWalletProvider(null))
    dispatch(setWalletType(null))
    dispatch(setConnection(null))

    let sessiondata = JSON.parse(
      localStorage.getItem('wc@2:client:0.3//session')
    )

    console.log(sessiondata)
    let accounts = sessiondata[0]?.namespaces?.eip155?.accounts?.[0]?.split(':')
    // const { chainId, accounts } = payload.params[0]
    // console.log(accounts)
    getbalance(accounts[2])
    dispatch(setConnection(sessiondata[0]))
    dispatch(setWalletAddress(accounts[2]))
    dispatch(getWalletProvider(sessiondata[0]))
    dispatch(setWalletType('WALLETCONNECT'))
    localStorage.setItem('WalletConnected', 1)
  }

  useEffect(() => {
    if (process.env.REACT_APP_ENVIRONMENT == 'live') {
      console.log = function () { }
    }

    if (typeof window?.ethereum !== 'undefined') {
      window?.ethereum?.on('accountsChanged', function (accounts) {
        const cancelButton = document?.getElementsByClassName('btn-close')
        for (let i = 0; i < cancelButton?.length; i++) {
          if (cancelButton[i] != undefined) {
            cancelButton[i]?.click()
          }
        }
        if (accounts.length == 0) {
          dispatch(setWalletAddress(''))
          dispatch(getWalletProvider(null))
          dispatch(setWalletType(''))
          dispatch(setWalletAmount(null))
          console.log('account disconnected')
          localStorage?.removeItem('WalletConnected')
        } else {
          getAccount()
        }
      })
    }
    if (typeof window?.ethereum !== 'undefined') {
      window.ethereum.on('chainChanged', data => {
        // window.location.reload();
        // window.scrollTo(0, 0);
        const element = document.getElementById('networkSwitch')
        console.log(element)
        console.log(data)
        // alert("Account Change")

        // alert(data)
        if (count == 1) {
          setCount(count + 1)
          if (process.env.REACT_APP_ENVIRONMENT == 'live') {
            if (localStorage.getItem('currentNetwork') == 'MUMBAI') {
              if (data == '0x89') {
                getAccount()
              } else {
                element?.click()
                // alert("Sorry you are on wrong chain")
              }
            } else if (localStorage.getItem('currentNetwork') == 'BINANCE') {
              if (data == '0x38') {
                getAccount()
              } else {
                element?.click()
              }
            } else {
              if (data == '0x1') {
                getAccount()
              } else {
                element?.click()
              }
            }
          } else {
            if (localStorage.getItem('currentNetwork') == 'MUMBAI') {
              if (data == 0x13881) {
                getAccount()
              } else {
                element?.click()
              }
            } else if (localStorage.getItem('currentNetwork') == 'BINANCE') {
              // alert("I am Awais Niaz")
              if (data == '0x61') {
                getAccount()
              } else {
                element?.click()
              }
            } else {
              if (data == '0x5') {
                getAccount()
              } else {
                element?.click()
              }
            }
          }
          // console.log(data)
        }
        // getAccount();
      })
    }
  }, [])
  useEffect(() => {
    $(window).on('popstate', function (event) {
      window?.location?.reload()

      try {
        var x = document.getElementsByTagName('BODY')?.[0]
        x.style.overflowY = 'scroll'
        x.style.paddingRight = 'unset'
        var elements = document.getElementsByClassName('modal-backdrop')
        for (var i = 0; i <= elements?.length; i++) {
          elements[i].style.display = 'none'
        }
      } catch (e) {
      } finally {
      }
    })
  }, [])

  const searchFiled = value => {
    console.log(window?.location?.pathname)
    if (value?.trim() == '') {
      setSearch(false)
      setSearchQuery('')
      localStorage.removeItem('search')
    } else {
      setSearch(true)
      setSearchQuery(value)
      localStorage.setItem('search', 1)
    }
  }
  async function getAccount() {
    const accounts = await window?.ethereum?.enable()
    const account = accounts[0]
    // do something with new account here
    dispatch(setWalletAddress(account))
    getbalance(account)
    try {
      var x = document.getElementsByTagName('BODY')?.[0]
      x.style.overflowY = 'scroll'
      x.style.paddingRight = 'unset'
      var elements = document.getElementsByClassName('modal-backdrop')
      for (var i = 0; i <= elements?.length; i++) {
        elements[i].style.display = 'none'
      }
    } catch (e) {
    } finally {
    }
  }

  const getbalance = async address => {
    // Requesting balance method

    const currentNetwork = localStorage.getItem('currentNetwork')
    var currentRpc = null
    if (currentNetwork == 'EHETERUM') {
      currentRpc = `${process.env.REACT_APP_RINKEY_RPC}`
    } else if (currentNetwork == 'BINANCE') {
      currentRpc = `${process.env.REACT_APP_BINANCE_RPC}`
    } else {
      currentRpc = `${process.env.REACT_APP_MUMBAI_RPC}`
    }

    const web3 = new Web3(currentRpc)
    let balancenew = await web3.eth.getBalance(address)
    balancenew = web3.utils.fromWei(balancenew, 'ether')

    dispatch(setWalletAmount(balancenew))
  }
  return (
    <BrowserRouter>
      <Affix offsetTop={0}>
        <Header
          searchFiled={searchFiled}
          search={search}
          searchQuery={searchQuery}
        />
      </Affix>
      {search == true ? (
        <React.Suspense fallback={<LoaderPending />}>
          {window?.location?.pathname == '/reward-listing' ? (
            <OldRewardesign
              title='Search Results'
              searchQuery={searchQuery}
              searchFiled={searchFiled}
            ></OldRewardesign>
          ) : (
            <SearchNFTS1 searchQuery={searchQuery} searchFiled={searchFiled} />
          )}
        </React.Suspense>
      ) : (
        <Routes>
          <Route path='/' element={<Home />}></Route>

          {[
            '/login',
            '/login/:nftToken',
            '/login/:nftToken/network/:network',
            '/login/rewards/:rewardId/:rewardname',
            '/login/:tokenId/:camelType'
          ]?.map(item => {
            return (
              <Route
                path={item}
                element={
                  <React.Suspense fallback={<LoaderPending />}>
                    <Login1 />
                  </React.Suspense>
                }
              ></Route>
            )
          })}

          <Route
            path='/signup'
            element={
              <React.Suspense fallback={<LoaderPending />}>
                <Signup1 />
              </React.Suspense>
            }
          ></Route>
          <Route
            path='/verify/token/:token/email/:email'
            element={
              <React.Suspense fallback={<LoaderPending />}>
                <VerifyAccount />
              </React.Suspense>
            }
          ></Route>
          <Route
            path='/forgetPassword'
            element={
              <React.Suspense fallback={<LoaderPending />}>
                <ForgetPassword1 />
              </React.Suspense>
            }
          ></Route>
          <Route
            path='/resetPassword/token/:token/email/:email'
            element={
              <React.Suspense fallback={<LoaderPending />}>
                <ResetPassword1 />
              </React.Suspense>
            }
          ></Route>
          {[
            '/connect-wallet',
            '/connect-wallet/:tokenId',
            '/connect-wallet/:tokenId/network/:network',
            '/connect-wallet/:backPage/:packpageId',
            '/connect-wallet/:backPage/:packpageId',
            '/connect-wallet/rewards/:rewardId/:rewardname',
            '/connect-wallet/camelgames/:tokenId/:camelType'
          ]?.map(item => {
            return (
              <Route
                path={item}
                element={
                  <React.Suspense fallback={<LoaderPending />}>
                    <ConnectWallet1 connectexsSport={props?.connectexsSport} />
                  </React.Suspense>
                }
              ></Route>
            )
          })}
          {[
            '/marketplace',
            '/marketplace/:type',
            '/marketplace/type/:type/network/:network/category/:category/sortby/:sortby',
            '/marketplace/network/:network/category/:category/sortby/:sortby'
          ]?.map(item => {
            return (
              <Route
                path={item}
                element={
                  <React.Suspense fallback={<LoaderPending />}>
                    <Cards1 />
                  </React.Suspense>
                }
              ></Route>
            )
          })}
          {[
            '/details/:id',
            '/details/:id/marketplacetype/:type',
            '/details/:id/network/:networkId',
            'details/:nftsToken/:nftsId'
          ]?.map(item => {
            return (
              <Route
                path={item}
                element={
                  <React.Suspense fallback={<LoaderPending />}>
                    <BuyNftDetail1 />
                  </React.Suspense>
                }
              ></Route>
            )
          })}
          <Route
            path='/slider'
            element={
              <React.Suspense fallback={<LoaderPending />}>
                <Slider1 />
              </React.Suspense>
            }
          ></Route>
          <Route
            path='/album'
            element={
              <React.Suspense fallback={<LoaderPending />}>
                <MyAlbum1 />
              </React.Suspense>
            }
          ></Route>
          <Route
            path='/myprofile'
            element={
              <React.Suspense fallback={<LoaderPending />}>
                <MyProfile1 />
              </React.Suspense>
            }
          ></Route>
          <Route
            path='/myreward'
            element={
              <React.Suspense fallback={<LoaderPending />}>
                <Reward1 />
              </React.Suspense>
            }
          ></Route>
          <Route
            path='/reward-listing'
            element={
              <React.Suspense fallback={<LoaderPending />}>
                <Rewardlisting1 />
              </React.Suspense>
            }
          ></Route>
          <Route
            path='/reward-detail/:id/:title'
            element={
              <React.Suspense fallback={<LoaderPending />}>
                <RewardDetail1 />
              </React.Suspense>
            }
          ></Route>
          {['/exstv', '/exstv/:name/:id']?.map(item => {
            return (
              <Route
                path={item}
                element={
                  <React.Suspense fallback={<LoaderPending />}>
                    <SportsTv1 />
                  </React.Suspense>
                }
              ></Route>
            )
          })}
          <Route
            path='/mywallet'
            element={
              <React.Suspense fallback={<LoaderPending />}>
                <MyWallet1 />
              </React.Suspense>
            }
          ></Route>
          <Route
            path='/terms-condition'
            element={
              <React.Suspense fallback={<LoaderPending />}>
                <Term1 />
              </React.Suspense>
            }
          ></Route>
          <Route
            path='/privacy'
            element={
              <React.Suspense fallback={<LoaderPending />}>
                <Privacy1 />
              </React.Suspense>
            }
          ></Route>
          <Route
            path='/faq'
            element={
              <React.Suspense fallback={<LoaderPending />}>
                <FAQ1 />
              </React.Suspense>
            }
          ></Route>
          <Route
            path='/road-map'
            element={
              <React.Suspense fallback={<LoaderPending />}>
                <RoadMap1 />
              </React.Suspense>
            }
          ></Route>
          <Route
            path='/contact-us'
            element={
              <React.Suspense fallback={<LoaderPending />}>
                <Contactus1 />
              </React.Suspense>
            }
          ></Route>
          <Route
            path='/partnership'
            element={
              <React.Suspense fallback={<LoaderPending />}>
                <Partnership1 />
              </React.Suspense>
            }
          ></Route>
          <Route
            path='/about-us'
            element={
              <React.Suspense fallback={<LoaderPending />}>
                <Aboutus1 />
              </React.Suspense>
            }
          ></Route>
          <Route
            path='/mobile-faq'
            element={
              <React.Suspense fallback={<LoaderPending />}>
                <MobileFAQ1 />
              </React.Suspense>
            }
          ></Route>
          {/* <Route path='/mobile-faq' element={<MobileFAQ/>}></Routes> */}
          <Route
            path='/activate/token/:token/email/:email'
            element={
              <React.Suspense fallback={<LoaderPending />}>
                <ActivateAccount1 />
              </React.Suspense>
            }
          ></Route>
          <Route
            path='/session'
            element={
              <React.Suspense fallback={<LoaderPending />}>
                <SessionExpire1 />
              </React.Suspense>
            }
          />
          <Route
            path='/metamask'
            element={
              <React.Suspense fallback={<LoaderPending />}>
                <MetaMask1 />
              </React.Suspense>
            }
          ></Route>
          <Route
            path='/topup'
            element={
              <React.Suspense fallback={<LoaderPending />}>
                <TopUp1 />
              </React.Suspense>
            }
          ></Route>
          <Route
            path='/success'
            element={
              <React.Suspense fallback={<LoaderPending />}>
                <Success1 />
              </React.Suspense>
            }
          ></Route>
          <Route
            path='*'
            element={
              <React.Suspense fallback={<LoaderPending />}>
                <NotFound1 TEXT={'Page Not Found'} Status={404} />
              </React.Suspense>
            }
          ></Route>
        </Routes>
      )}
      <Footer />
    </BrowserRouter>
  )
}

export default Router
